<div class="cf-dlg" [class.pcf-page]="!dialogRef">
  <div class="cf-dlg-header">
    <div class="cf-dlg-icon"><mat-icon>credit_card</mat-icon></div>
    <div class="pcf-header-text">
      <h2 class="cf-dlg-title">{{ dialogTitle }}</h2>
      <p class="cf-dlg-subtitle" *ngIf="flagImport">Importación: {{ movement?.reference }}</p>
      <p class="cf-dlg-subtitle" *ngIf="!flagImport">Datos de la tarjeta y cuenta bancaria asociada</p>
    </div>
    <button mat-icon-button class="cf-dlg-close" (click)="cancel()" [disabled]="saving" aria-label="Cerrar">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <app-loading-state *ngIf="!ready" message="Cargando tarjeta…"></app-loading-state>
  <app-loading-state *ngIf="ready && saving" message="Guardando tarjeta…"></app-loading-state>

  <ng-container *ngIf="ready && !saving && loadError">
    <div class="cf-dlg-body">
      <div class="cf-dlg-mismatch">
        <mat-icon>error</mat-icon>
        <span>No se pudo cargar la tarjeta.</span>
      </div>
    </div>
    <div class="cf-dlg-footer">
      <button type="button" mat-stroked-button class="cf-dlg-btn-secondary" (click)="cancel()">Cerrar</button>
      <button type="button" mat-flat-button class="cf-dlg-btn-primary" (click)="load()">
        <mat-icon>refresh</mat-icon> Reintentar
      </button>
    </div>
  </ng-container>

  <ng-container *ngIf="ready && !saving && !loadError">
    <form class="pcf-form" (ngSubmit)="save()" novalidate>
      <div class="cf-dlg-body">
        <div class="cf-dlg-mismatch" *ngIf="saveError">
          <mat-icon>error</mat-icon>
          <span>{{ saveError }}</span>
        </div>

        <span class="cf-dlg-section__label">Tarjeta</span>

        <div class="cf-field--required" [class.cf-field--invalid]="submitted && missingName">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Nombre</mat-label>
            <input matInput name="name" [(ngModel)]="paymentCard.name" autocomplete="off" maxlength="255">
          </mat-form-field>
          <div class="cf-field__error" *ngIf="submitted && missingName"><mat-icon>error</mat-icon> Indica un nombre para la tarjeta</div>
        </div>

        <div class="pcf-row">
          <div class="cf-field--required" [class.cf-field--invalid]="submitted && missingNumber">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Número de tarjeta</mat-label>
              <input matInput name="number" [(ngModel)]="paymentCard.number" autocomplete="off" maxlength="255">
              <mat-icon matSuffix>credit_card</mat-icon>
            </mat-form-field>
            <div class="cf-field__error" *ngIf="submitted && missingNumber"><mat-icon>error</mat-icon> Indica el número de tarjeta</div>
          </div>

          <div [class.cf-field--invalid]="submitted && invalidExpiring">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Caducidad (MM/AA)</mat-label>
              <input matInput name="expiring" [(ngModel)]="expiring" placeholder="05/28" autocomplete="off" maxlength="7">
            </mat-form-field>
            <div class="cf-field__error" *ngIf="submitted && invalidExpiring"><mat-icon>error</mat-icon> Usa el formato MM/AA</div>
          </div>
        </div>

        <span class="cf-dlg-section__label">Cuenta bancaria asociada</span>

        <div class="cf-field--required" [class.cf-field--invalid]="submitted && missingBankAccount">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Cuenta bancaria</mat-label>
            <mat-select name="bankAccountUid" [(ngModel)]="paymentCard.bankAccountUid">
              <mat-option *ngFor="let account of bankAccounts" [value]="account.uid">
                {{ account.bank }}{{ account.bank && account.iban ? ' · ' : '' }}{{ account.iban }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <div class="cf-field__error" *ngIf="submitted && missingBankAccount"><mat-icon>error</mat-icon> Selecciona la cuenta bancaria</div>
          <div class="pcf-hint" *ngIf="!bankAccounts.length">No tienes cuentas bancarias. Crea una en Finanzas › Cuentas bancarias.</div>
        </div>
      </div>

      <div class="cf-dlg-footer">
        <button type="button" mat-stroked-button class="cf-dlg-btn-secondary" (click)="cancel()">Cancelar</button>
        <button type="submit" mat-flat-button class="cf-dlg-btn-primary">
          <mat-icon>save</mat-icon> Guardar
        </button>
      </div>
    </form>
  </ng-container>
</div>
